import { get } from '@/api/general';

export default {
    productOptions: (categoryId) => get(`categories/${categoryId}/product/options`),
    select: (params) => get('categories/select', params),
    notLinked: (externalServiceId, params) => get(`categories/notLinked/${externalServiceId}`, params),
    specOptions: (categoryId) => get(`categories/${categoryId}/specification/options`),
};
